import React, { useEffect } from 'react';
import { Form, Button, Row, Col, Select, Spin, Input } from 'antd';
import { ReactSVG } from 'react-svg';

const DRIVER_APPROVAL_STATUSES = {
  PENDING: 'Pending',
  APPROVED: 'Approved',
  REJECTED: 'Rejected',
  LOCKED: 'Locked',
};

const DriversFilter = ({ isFetching, query, onSubmit }) => {
  const [form] = Form.useForm();

  const statusField = 'approvalStatus';
  const statusValue = query[statusField];

  useEffect(() => {
    form.setFieldsValue(initialValues());
  }, [query]);

  const initialValues = () => {
    const values = {};
    // Handle both string and array (default case)
    if (Array.isArray(statusValue)) {
      values[statusField] = statusValue.length === 1 ? statusValue[0] : statusValue;
    } else {
      values[statusField] = statusValue || '';
    }
    values['internalId'] = query.internalId || '';
    return values;
  };

  const handleSubmit = (values) => {
    const params = {};
    if (values[statusField]) {
      params[statusField] = values[statusField];
    } else {
      params[statusField] = undefined;
    }
    if (values.internalId) {
      params.internalId = values.internalId;
    } else {
      params.internalId = undefined;
    }
    onSubmit({ ...query, ...params, current: 1 }, true);
  };

  const handleResetButton = () => {
    // Reset to default: APPROVED
    onSubmit({ current: 1 }, true);
  };

  return (
    <Spin spinning={isFetching}>
      <div className="CommonFilter DriversFilter">
        <Form
          form={form}
          onFinish={handleSubmit}
          initialValues={initialValues()}
          className="FilterForm DriversFilterForm"
          layout="vertical"
        >
          <div className="FilterFormHeader">
            <h4>Filter</h4>
            <div className="actions">
              <Button size="small" type="text" onClick={handleResetButton}>
                Clear
                <ReactSVG className="icon" src="/icons/clear_all.svg" />
              </Button>
              <Button className="apply" size="small" type="link" htmlType="submit">
                Apply
                <ReactSVG className="icon" src="/icons/done.svg" />
              </Button>
            </div>
          </div>
          <div className="FilterFormContent">
            <Row gutter={15}>
              <Col xs={{ span: 24 }} md={{ span: 6 }}>
                <Form.Item label="Approval Status" name={statusField}>
                  <Select
                    className="select-small"
                    options={[
                      { label: 'ALL', value: '' },
                      ...Object.keys(DRIVER_APPROVAL_STATUSES).map((key) => ({
                        label: DRIVER_APPROVAL_STATUSES[key],
                        value: key,
                      })),
                    ]}
                  />
                </Form.Item>
              </Col>
              <Col xs={{ span: 24 }} md={{ span: 6 }}>
                <Form.Item label="Driver ID" name="internalId">
                  <Input placeholder="Driver ID" className="input-small" />
                </Form.Item>
              </Col>
            </Row>
          </div>
        </Form>
      </div>
    </Spin>
  );
};

export default DriversFilter;
